import styled from "styled-components";

export const LightBg = styled.div`
    font-family: Inter;
    padding: 75px 125px;
    background: #FFFFFF;
    font-family: 'Inter', sans-serif;
`;

export const ParentCard = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    margin-top: 50px;
    margin-bottom: 50px;
    gap: 1rem;
    font-family: 'Inter', sans-serif;
`;

export const Card = styled.div`
    width: 720px;
    padding-left: 10%;
    padding-right: 10%;
    padding-top: 3%;
    padding-bottom: 3%;
    border: 2px solid #DADADA;
    border-radius: 10px;
`;


  